import { render, staticRenderFns } from "./AllocationChartModal.vue?vue&type=template&id=36061681&scoped=true"
import script from "./AllocationChartModal.vue?vue&type=script&lang=ts"
export * from "./AllocationChartModal.vue?vue&type=script&lang=ts"
import style0 from "./AllocationChartModal.vue?vue&type=style&index=0&id=36061681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36061681",
  null
  
)

export default component.exports